<template>
  <v-card
    class="hyp-risk-seerist-swirl"
    :id="wrapperId"
    v-resize="this.toggleRisksContentExpandResize"
    :class="[risksContentExpanded ? 'hyp-risks-content-expanded' : '']"
  >
    <v-icon
      v-if="!expandBtnTitle || risksContentExpanded"
      class="hyp-risks-content-wrapper-expand-btn ml-3 pull-right"
      size="16"
      @click="toggleRisksContentExpand()"
      :class="wrapperClass"
      >fas fa-expand-alt</v-icon
    >
    <v-btn
      v-if="expandBtnTitle && expandBtnTitle != '' && !risksContentExpanded"
      @click="toggleRisksContentExpand()"
      class="hyp-risks-content-wrapper-expand-btn ml-3 mt-2 mr-2 pull-right"
      small
      outlined
    >
      {{ expandBtnTitle }}
      <v-icon class="pl-3" size="14">fas fa-expand-alt</v-icon>
    </v-btn>

    <slot></slot>
  </v-card>
</template>

<script>
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";
const EMITTED_ACTIONS = {
  CLICK_EXPAND: "click-expand",
  CLICK_COLLAPSE: "click-collapse",
  REFRESH_CONTENT: "refresh-content",
};
export default {
  name: "RisksContentContainerWrapper",
  props: {
    wrapperClass: {
      type: String,
      default: "",
    },
    wrapperId: {
      type: String,
      required: true,
    },
    expandBtnTitle: {
      type: String,
      default: "",
    },
    resetExpanded: {
      type: String,
      required: true,
    },
    expand: {
      type: Number,
    },
  },
  data() {
    return {
      risksContentExpanded: false,
    };
  },
  methods: {
    toggleRisksContentExpand() {
      this.risksContentExpanded = !this.risksContentExpanded;
      this.toggleRisksContentExpandResize();
      this.$emit(EMITTED_ACTIONS.REFRESH_CONTENT, this.expand + 1);
      if (
        this.risksContentExpanded &&
        this.wrapperId !== "risks-pulse-ratings"
      ) {
        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.control_risk_content,
          EVENT_ACTIONS.expanded,
          "Country risk - " + this.wrapperId + " expanded"
        );
      }
    },
    toggleRisksContentExpandResize() {
      let el = document.getElementById(this.wrapperId);
      if (this.risksContentExpanded) {
        let wrapperEl = document.getElementById("hyp-risk-grid");
        if (el && wrapperEl) {
          el.style.height =
            window.innerHeight -
            wrapperEl.getBoundingClientRect().y -
            12 +
            "px";
          el.style.width =
            window.innerWidth - wrapperEl.getBoundingClientRect().x - 24 + "px";
          el.style["overflow-y"] = "hidden";

          if (el.classList.contains("expand-left")) {
            el.style["margin-left"] =
              "-" +
              (window.innerWidth - wrapperEl.getBoundingClientRect().x - 24) /
                2 +
              "px";
          }

          this.$emit(EMITTED_ACTIONS.CLICK_EXPAND);
        }
      } else {
        if (el) {
          el.style.height = "";
          el.style.width = "";
          el.style["overflow-y"] = "";
          if (el.classList.contains("expand-left")) {
            el.style["margin-left"] = "";
          }
          el.scrollTop = 0;
          this.$emit(EMITTED_ACTIONS.CLICK_COLLAPSE);
        }
      }
    },
  },
  watch: {
    resetExpanded: {
      handler() {
        this.risksContentExpanded = false;
        this.toggleRisksContentExpandResize();
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.hyp-risks-content-wrapper-expand-btn {
  z-index: 1111;
}
.hyp-risks-content-expanded {
  position: absolute;
  transition-property: sliding-vertically;
  /* width: calc(100vw - 528px); */
  transition: all 0.5s ease-out;
  /* height: 85vh; */
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 9999;
}
>>> .v-icon.v-icon::after {
  left: -6px;
  top: 6px;
}
</style>
<style>
.hyp-risks-content-expanded.hyp-risk-seerist-swirl {
  background-image: url("../../../assets/images/seerist_swirl_large.png");
  background-position: unset;
  background-repeat: no-repeat;
  background-size: contain;
}
.hyp-risks-content-expanded.hyp-risk-seerist-swirl > .v-card {
  background: transparent;
}
.hyp-risks-content-expanded.hyp-risk-seerist-swirl .content-container {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 24px 12px 12px 12px !important;
}
.hyp-risks-content-expanded.hyp-risk-seerist-swirl .v-tabs,
.hyp-risks-content-expanded.hyp-risk-seerist-swirl .v-tabs-bar {
  background: transparent !important;
}
.hyp-risks-content-expanded .content-container > .v-card {
  height: 100% !important;
  overflow-y: auto !important;
  padding-bottom: 100px !important;
}
#risks-pulse-ratings.hyp-risks-content-expanded {
  overflow-y: auto !important;
}
</style>
